import Content from "uxp-documentation/src/pages/uxp-api/reference-css/Selectors/General Sibling combinator";
import * as React from 'react';
export default {
  Content,
  React
};